app.service('searchService', function ($http) {
  let googleAddressKeys   = ['street_number', 'route', 'neighborhood', 'locality', 'administrative_area_level_2', 'administrative_area_level_1', 'country', 'postal_code', 'postal_code_suffix']
  let googleKeyConversion = ['street_number', 'street_name', 'neighborhood', 'city', 'county', 'state', 'country', 'zip', 'zip_suffix']
  let googleCounties      = []
  let countyCodes         = []
  let countyListObj       = null

  this.getPropUID = function (obj) {
    return $http.post('/properties/getPropUID', obj)
      .then(function (response) {
        return response
      })
  }

  this.getTaxIDs = function (obj) {
    return $http.post('/properties/gettaxids', obj)
      .then(function (response) {
        return response
      })
  }

  this.getStreets = function (obj) {
    return $http.post('/properties/getStreets', obj)
      .then(function (response) {
        return response
      })
  }

  this.setGoogleCounties = (obj) => {
    this.setCountyList(obj)
    console.log('obj :>> ', obj);
    googleCounties = []
    countyCodes    = []
    obj.map(item => {
      googleCounties.push(item.name)
      countyCodes.push(item.cad_code)
    })    
    return googleCounties.join()
  }

  this.setCountyList = (obj) => {
    countyListObj = obj
  }
  this.getCountyList = () => {
    return countyListObj
  }

  this.convertGoogleResponseToObject = function (place) {
    var retObj = {}
    var addressInfo = place.address_components
    // Build Address Obj
    for (var a in addressInfo) {
      var keyPosition = googleAddressKeys.indexOf(addressInfo[a].types[0]);
      if (keyPosition > -1) {
        retObj[googleKeyConversion[keyPosition]] = addressInfo[a]
      }
    }
    // Get Formatted Address
    if (place.formatted_address) {
      retObj.formatted_address = place.formatted_address.replace(", USA", "")
    }
    // Get County Code

    console.log('countyCodes :>> ', countyCodes);
    console.log('googleCounties :>> ', googleCounties);
    console.log('googleCounties.indexOf(retObj.county.long_name) :>> ', googleCounties.indexOf(retObj.county.long_name));
    if (retObj.county) {      
      var cad_code = countyCodes[googleCounties.indexOf(retObj.county.long_name)]
      
      if (cad_code == undefined) {
        retObj['cad_code'] = '000'
      } else {
        retObj['cad_code'] = String(cad_code)
      }
    } else {
      retObj['cad_code'] = '000'
    }
    return retObj
  }

})
